import React, { PureComponent } from 'react';

//Custom Components

import { SelectList } from '../Utilities/SelectList'
import  PrintableClientsTable  from '../Utilities/PrintableClientsTable'

import { Input } from '../Utilities/Input'
import { ModalDialog } from '../Utilities/ModalDialog'
//Database Services
import { getDocumentsByStatus, deleteDocument, renameDocument, newOwnerFolder, deleteFolder, renameFolder, addEvent, downloadDocument, setDocumentStatus, addNote, openDocumentInNewTab} from '../../DataServices/DocumentService'
import { getClientDocsByStatus, getClientsWithDocsByStatus } from '../../DataServices/BusinessService'

//Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faFilePdf, faFileWord, faFileExcel, faImage, faFile } from '@fortawesome/free-solid-svg-icons'

//Material UI

import Stack from '@mui/material/Stack';
import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { CardActionArea } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';

const convertUTCDateToLocalDate = (date) => {
    var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

    var offset = date.getTimezoneOffset() / 60;
    var hours = date.getHours();

    newDate.setHours(hours - offset);

    return newDate.toLocaleString();
}

const docTypeList = () => {
    return [{ value: 0, label: Document },];
}
const statusList = () => {
    return [
        { value: 0, label: "New" },
        { value: 1, label: "Sent" },
        { value: 2, label: "Printed" },
        { value: 3, label: "SDrive" },
        { value: 4, label: "Resolved" },
        { value: 5, label: "Archived" },
    ];
}
const TabPanel = (props) => {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`docs-tabpanel-${index}`}
            aria-labelledby={`docs-tab-${index}`}
            style={{ minWidth: "130px" }}
            {...other}
        >
            {value === index && children}
        </div>
    );
}

export class NewDocuments extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            selectedStatus: 0,
            showPrint: false
        }
    }
    componentDidMount() {
        this.getClientsWithDocsByStatus(this.state.selectedStatus);
    }

    getClientsWithDocsByStatus = async (status) => {
        const clientswithdocs = await getClientsWithDocsByStatus(this.props.businessID, status);
        this.setState({ clientswithdocs });
    }
    //Event Handlers
    handleClickClient = async (e, id, idx, ) => {
        const clientDocs = await getClientDocsByStatus(id, this.state.selectedStatus);
        this.setState({ selectedClientID: id, clientDocs });
    }
    handleChangeStatus = (status) => {
        this.setState({ selectedStatus: status, clientDocs: null });
        this.getClientsWithDocsByStatus(status);
        this.forceUpdate();
    }
    handleClickDocument = async (e, id, name) => {
       // const doc = await downloadDocument(id, name);
        await openDocumentInNewTab(id);
    }
    handleClickNotes = async (e, id, note, idx) => {
        this.setState({ selectedDocID: id, selectedDocIDX: idx, selectDocNote: note, showNoteAdder: true });

    }
    handleChangeDocStatus = (e, id, idx, clientindex) => {
        this.setDocStatus(id, e);
        this.addDocEvent(id, e);
        const clientDocs = this.state.clientDocs;
        clientDocs.splice(idx, 1);
        let clientswithdocs = this.state.clientswithdocs;
        if (clientDocs.length == 0) {
            
            clientswithdocs.splice(clientindex, 1);
        }
        else {
            clientswithdocs[clientindex].numDocs--;
        }
        this.setState({ clientDocs, clientswithdocs });
        
        this.forceUpdate();
        
    }

    setDocStatus = (id, status) => {
        const suc =  setDocumentStatus(id, status);
    }

    addDocEvent = (id,status) => {
        const ret = addEvent(id, "0", 5, this.state.selectedStatus, status);
    }
    saveNote = (note) => {
        const ret = addNote(this.state.selectedDocID, note);
        const clientDocs = this.state.clientDocs;
        clientDocs[this.state.selectedDocIDX].notes = note;

        this.setState({ clientDocs, showNoteAdder: false });
    }
    //Render functions
    setIcon = (doc) => {
        var fileExt = doc.split('.').pop();
        switch (fileExt) {
            case "pdf":
                return faFilePdf;
            case "doc":
            case "docx":
                return faFileWord;
            case "xls":
            case "xlsx":
                return faFileExcel;
            case "tiff":
            case "jpg":
            case "jpeg":
            case "png":
            case "bmp": 
                return faImage;
            default:
                return faFile;

        }

    }
    docStatusSelector = () => {
        return (

                  <SelectList
                    dark={this.props.dark}
                    key="docstatuses"
                    label="Status"
                    value={this.state.selectedStatus}
                    onChange={(e) => this.handleChangeStatus(e)}
                listItems={statusList()}
                width="30%"
                />
            )
    }

    notes = () => {
        return (
            <ModalDialog
                dark={this.state.width <= 600 ? true : this.props.dark}
                show={this.state.showNoteAdder}
                handleClose={() => this.setState({ showNoteAdder: false })}
                closeLabel="Close"
                fullWidth={true}
                title="Document Notes"
                noPad={true}
                hideScroll={true}
                disableButtons
            >
                <Input
                    dark={this.props.dark}
                    key="noteadder"
                    label="Add Note"
                    defaultValue={this.state.selectDocNote ?? ""}
                    multiline
                    maxRows={4}
                    rows={4}
                    type="text"
                    onBlur={(val) => this.saveNote(val)}

                />
            </ModalDialog>
        )
    }
    docCard = (doc, index) => {
        return (
            <Card square elevation={0} sx={{ background: "transparent" }}>
                <Stack>
                <CardActionArea onClick={(e) => this.handleClickClient(e, doc.clientID, index)} >
                    <CardContent sx={{  }}>
                        <Box display="flex" >
              
                                <Stack direction="row" spacing={2} sx={{ width: "100%", color: (theme) => this.props.dark ? theme.palette.common.dimwhite : theme.palette.common.dimblack }}>
                                    <Typography gutterBottom variant="subtitle1" sx={{ fontSize: ".9rem", marginBottom: 0, width: "20%" }}>
                                        {doc.clientName ? doc.clientName : "Client"}
                                    </Typography>

                                    <Typography variant="body2" sx={{ fontSize: ".8rem", width: "20%", color: (theme) => this.props.dark ? theme.palette.common.dimwhite : theme.palette.common.dimblack }}>
                                        {doc.clientAltID}
                                    </Typography>
                                    <Typography variant="body2" sx={{ fontSize: ".8rem", width: "20%", color: (theme) => this.props.dark ? theme.palette.common.dimwhite : theme.palette.common.dimblack }}>
                                        {doc.documentStatus}
                                    </Typography>
                                    <Typography variant="body2" sx={{ fontSize: ".8rem", width: "20%", color: (theme) => this.props.dark ? theme.palette.common.dimwhite : theme.palette.common.dimblack }}>
                                        Last Upload on {new Date(doc.lastUpload).toLocaleString()}
                                    </Typography>

                                    <Typography variant="body2" sx={{ fontSize: ".8rem", width: "20%", color: (theme) => this.props.dark ? theme.palette.common.dimwhite : theme.palette.common.dimblack }}>
                                        {doc.numDocs} File{doc.numDocs > 1 && "(s)"}
                                    </Typography>
                                </Stack>

                       

                        </Box>
                    </CardContent>
                    </CardActionArea>
                    {this.state.selectedClientID == doc.clientID && this.clientDocDisplay(doc.clientID, index) }
                </Stack>
            </Card>
        )
    }
    clientDocCard = (doc, idx, clientindex) => {
        return (

            <Box display="flex" >

                <Stack direction="row" spacing={2} sx={{ width: "100%", color: (theme) => this.props.dark ? theme.palette.common.dimwhite : theme.palette.common.dimblack }}>
                    <Button variant="text" onClick={(e) => this.handleClickDocument(e, doc.documentID, doc.documentName)} sx={{ justifyContent:"left", fontSize: ".7rem", width: "35%", color: (theme) => this.props.dark ? theme.palette.common.dimwhite : theme.palette.common.dimblack }}>

                            {doc.documentName}

                    </Button>
                    <Typography sx={{ marginTop: "auto!important", marginBottom: "auto!important", fontSize: ".7rem", width: "20%", color: (theme) => this.props.dark ? theme.palette.common.dimwhite : theme.palette.common.dimblack }}>
                        {convertUTCDateToLocalDate(new Date(doc.createDate))}
                    </Typography>
                    <SelectList
                        dark={this.props.dark}
                        key="docstatuse"
                        label="Status"
                        value={statusList().find(status => status.label === doc.documentStatus).value}
                        onChange={(e) => this.handleChangeDocStatus(e, doc.documentID, idx, clientindex)}
                        listItems={statusList()}
                        width="20%"
                    />


                        <Button variant="text" onClick={(e) => this.handleClickNotes(e, doc.documentID, doc.notes, idx)} sx={{ fontSize: ".7rem", width: "20%", color: (theme) => this.props.dark ? theme.palette.common.dimwhite : theme.palette.common.dimblack }}>
                            {doc.notes ? "Has Notes" : "Add Note"}
                        </Button>
         

                </Stack>


            </Box>

        )
    }
    printableList = () => {
        return (

                        <ModalDialog

                show={this.state.showPrint}
                handleClose={() => this.setState({ showPrint: false })}
                closeLabel="Close"
                fullWidth={true}
                fullScreen

                hideScroll={true}
                disableButtons
            >
                <PrintableClientsTable
                    rows={this.state.clientswithdocs}  // whatever the user is currently viewing
                    title="Clients With Documents"
                    subtitle="Current selection from the dashboard"
                />
            </ModalDialog>
            )
    }
    clientDocDisplay = (id, clientindex) => {
        return (
            <Box display="block" sx={{ borderTop: "1px solid rgba(145, 158, 171, 0.24)", padding: "0px", width: "100%", height: "100%", display: 'flex', flexGrow: 1, background: (theme) => this.props.dark ? "#050505" : theme.palette.component3.light, }} className="prettyScroll">
                <Grid container spacing={0.5} columns={{ xs: 1 }} >
                    {this.state.selectedClientID == id && this.state.clientDocs && this.state.clientDocs.map((item, index) => {
                        return (
         
                                <Grid item key={"clt" + item.id} xs={1} sm={1} md={1} lg={1} xl={1} sx={{
                                    transition: "transform .2s",
                                    "&:hover": { transform: "scale(1.01)" },
             
                                borderColor: (theme) => this.props.dark ? theme.palette.common.dimblack : "#ccc",
             
                                mx: 4,
                                    my: 1
                                }}>
                                    {this.clientDocCard(item, index, clientindex)}
                                </Grid>
                        

                        )
                    })}
                </Grid>
            </Box>
            )

    }
    render() {
        return (
            <React.StrictMode>
                <Box display="flex" sx={{ borderTop: "1px solid rgba(145, 158, 171, 0.24)", padding: "0px", width: "100%", height: "100%", display: 'flex', flexGrow: 1, background: (theme) => this.props.dark ? "#050505" : theme.palette.component3.light, }} className="prettyScroll">
                    <Stack sx={{ width: "-webkit-fill-available" }}>
                        <Stack direction="row" spacing={2}>
                            {this.docStatusSelector()}
                            <Button variant="text" onClick={(e) => this.setState({ showPrint: true })} sx={{ color: (theme) => this.props.dark ? theme.palette.common.dimwhite : theme.palette.common.dimblack }}>
                                Print
                            </Button>
                        </Stack>
             
                    <Grid container spacing={0.5} columns={{ xs: 1 }} >
                       
                        {this.state.clientswithdocs && this.state.clientswithdocs.map((item2, index2) => {
                            return (
                                <Grid item key={"clt" + item2.clientID} xs={1} sm={1} md={1} lg={1} xl={1} sx={{
                                    transition: "transform .2s",
                                    "&:hover": { transform: "scale(1.01)" },
                                    borderBottom: "1px solid",
                                    borderColor: (theme) => this.props.dark ? theme.palette.common.dimblack : "#ccc"
                                }}>
                                    {this.docCard(item2, index2)}
                                </Grid>
                            )
                        })}
                        </Grid>
                    </Stack>
                </Box>
                {this.state.showNoteAdder && this.notes()}
                {this.state.showPrint && this.printableList() }
            </React.StrictMode>
        )
    }
}
